<script setup lang="ts">
import { selectionActions } from "@/action/selectionActions";
import { actionSourceKey } from "@/components/action/injectKeys";
import { dropdownKey } from "@/components/ui/DropdownMenu/injectKeys";
import MenuList from "@/components/ui/MenuList/MenuList.vue";
import MenuListItem from "@/components/ui/MenuList/MenuListItem.vue";
import MenuListItems from "@/components/ui/MenuList/MenuListItems.vue";
import { injectStrict } from "@/utils/vue";

const dropdown = injectStrict(dropdownKey);
const actionSource = injectStrict(actionSourceKey);

function executeAction(action: (typeof selectionActions)[keyof typeof selectionActions]) {
  void action(actionSource);
  dropdown.close();
}
</script>

<template>
  <MenuList role="dialog">
    <MenuListItems>
      <MenuListItem
        :icon="selectionActions.alignHorizontal.data.icon"
        @click="executeAction(selectionActions.alignHorizontal)"
      >
        {{ $t(selectionActions.alignHorizontal.data.name) }}
      </MenuListItem>
      <MenuListItem
        :icon="selectionActions.distributeHorizontal.data.icon"
        @click="executeAction(selectionActions.distributeHorizontal)"
      >
        {{ $t(selectionActions.distributeHorizontal.data.name) }}
      </MenuListItem>
      <MenuListItem
        :icon="selectionActions.alignVertical.data.icon"
        @click="executeAction(selectionActions.alignVertical)"
      >
        {{ $t(selectionActions.alignVertical.data.name) }}
      </MenuListItem>
      <MenuListItem
        :icon="selectionActions.distributeVertical.data.icon"
        @click="executeAction(selectionActions.distributeVertical)"
      >
        {{ $t(selectionActions.distributeVertical.data.name) }}
      </MenuListItem>
      <MenuListItem
        :icon="selectionActions.lineup.data.icon"
        @click="executeAction(selectionActions.lineup)"
      >
        {{ $t(selectionActions.lineup.data.name) }}
      </MenuListItem>
      <MenuListItem
        :icon="selectionActions.arrange.data.icon"
        @click="executeAction(selectionActions.arrange)"
      >
        {{ $t(selectionActions.arrange.data.name) }}
      </MenuListItem>
      <MenuListItem
        :icon="selectionActions.stack.data.icon"
        @click="executeAction(selectionActions.stack)"
      >
        {{ $t(selectionActions.stack.data.name) }}
      </MenuListItem>
    </MenuListItems>
  </MenuList>
</template>
